'use client';

import React, { FC } from 'react';
import { Autoplay, FreeMode } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import { PartnerType } from '@/api/config/types';
import { useTranslation } from '@/hooks/useTranslations';

import Image from '../core/Image';

import './styles.scss';
import 'swiper/css';

// The partner list comes from the server (components/TrustedPartners/index.tsx)
const TrustedPartnersMarquee: FC<{ partners?: PartnerType[] }> = ({ partners: forMarquee }) => {
  const { t } = useTranslation();

  const settings = {
    loop: true,
    spaceBetween: 100,
    slidesPerView: 6,
    modules: [FreeMode, Autoplay],
    autoplay: {
      delay: 1,
      disableOnInteraction: false,
    },
    speed: 11000,
    breakpoints: {

      320: {
        slidesPerView: 3,
        spaceBetween: 32,
      },
      768: {
        slidesPerView: 4,
        spaceBetween: 40,
      },
      991: {
        slidesPerView: 4,
        spaceBetween: 50,
      },
      1200: {
        slidesPerView: 5,
        spaceBetween: 70,
      },
      1400: {
        slidesPerView: 6,
        spaceBetween: 100,
      },
    },
  };

  return (
    <div className="ourTrustedWrpInner" id="partners">
      <div className="ourTrustedTitleRow">
        <h3 className="ourTrustedTitleText">{t('Homepage-Partners')}</h3>
      </div>
      {forMarquee && (
        <div className="bottomSliderWrapper">
          <div className="bottomLogoSlider">
            <Swiper {...settings} className={'swiper-container-free-mode'}>
              {forMarquee.slice(0, forMarquee.length / 2).map((partner, index) => (
                <SwiperSlide key={`${partner.partnerName}-${index}`}>
                  <Image
                    width={225}
                    height={30}
                    // moving marquee: lazy loading would make logos pop in while they slide
                    loading="eager"
                    // the logos are in the HTML now: load them after the page's main images
                    fetchPriority="low"
                    alt="partners"
                    src={partner.logo}
                    key={`${partner.partnerName}-${index}`}
                    className={`imgLogoSlider ${partner.partnerName}`}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          <div className={'bottomLogoSlider'}>
            <Swiper
              {...settings}
              autoplay={{
                reverseDirection: true,
                delay: 1,
                disableOnInteraction: false,
              }}
              className={'swiper-container-free-mode'}
            >
              {forMarquee.slice(forMarquee.length / 2, forMarquee.length).map((partner, index) => (
                <SwiperSlide key={`${partner.partnerName}-${index}`}>
                  <Image
                    width={225}
                    height={30}
                    // moving marquee: lazy loading would make logos pop in while they slide
                    loading="eager"
                    // the logos are in the HTML now: load them after the page's main images
                    fetchPriority="low"
                    alt="partners"
                    src={partner.logo}
                    key={`${partner.partnerName}-${index}`}
                    className={`imgLogoSlider ${partner.partnerName}`}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      )}
    </div>
  );
};

export default TrustedPartnersMarquee;
